if(!customElements.get("product-tabs")){
  class t extends HTMLElement{
    constructor(){
      super();
      this.id=this.getAttribute("id");
      Shopify.designMode&&window.addEventListener("shopify:section:load",this.init.bind(this));
    }
    connectedCallback(){this.init()}
    init(){
      this.querySelectorAll(".product__tab--trigger").forEach(t=>{
        t.addEventListener("click",e=>{this.openTab(e,t.dataset.tab)})
      });
      this.openDefaultTab();
    }
    openDefaultTab(){
      const defaultTab=this.querySelector(".product__tab[data-default-open]");
      if(!defaultTab) return;
      // Call openTab directly instead of dispatching a real bubbling click event
      this.openTab({currentTarget: defaultTab}, defaultTab.dataset.tab);
    }
    openTab(t,e){
      this.querySelectorAll(".product__tab-content").forEach(t=>{t.style.display="none"});
      this.querySelectorAll(".product__tab").forEach(t=>{t.classList.remove("active")});
      const s=this.querySelector(`#${e}`);
      s&&(s.style.display="block",t.currentTarget&&t.currentTarget.classList.add("active"));
    }
  }
  customElements.define("product-tabs",t);
}